import React from "react";
import { HashRouter, Route, Switch } from "react-router-dom";
import { AppConfig } from "."; 
import { RouteProps, useHistory, useLocation } from "react-router-dom";
import { FunctionComponent, useEffect } from "react";
import { useIsLoggedInQuery } from "./graphql/generated/graphql";
import Login from "./routes/Login/LoginWithTranslations";
import useServiceWorker from './shared/Hooks/useServiceWorker';

// ««·· imports
import './i18n';
import BarcodeDemo from "./routes/BarcodeDemo";
import Home from "./routes/Home";
import NFC from "./routes/NFC";
import Invitation from "./routes/PartnerPortal/Invitation";
import Inventory from "./routes/Warehouse/Inventory";
import ListInventories from "./routes/Warehouse/ListInventories";
import ListReceipts from "./routes/Warehouse/ListReceipts";
import Picking from "./routes/Warehouse/Picking";
import Reception from "./routes/Warehouse/Reception";
import Release from "./routes/Warehouse/Release";
import Layout from './shared/LayoutWithTranslations';
// ··»»

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
export default function Component(props: { appConfig: AppConfig })
{
  // eslint-disable-next-line
  const serviceWorkerState = useServiceWorker();
  
  const { data } = useIsLoggedInQuery();

  const AuthorizedRoute: FunctionComponent<RouteProps> = (props) =>
  {
    const location = useLocation();
    const history = useHistory();

    useEffect(() =>
    {
      if(!data?.isLoggedIn)
      {
        history.replace(`/login?returnurl=${location.pathname}`);
      }
    });

    return <Route render={({ location }) => data?.isLoggedIn ? props.children : <></>} />
  };

  const queryToObject = (query: string) =>
  {
    const allParams = new URLSearchParams(query);
    let result: any = {};
    allParams.forEach((v, k) => result[k] = v);
    return result;
  };
  

  // ««·· render
  // ··»»

  return (
    <HashRouter basename={baseUrl!}>
      <Switch>
        {/* ««·· routes */}
        <Route exact path="/">
          <Layout env={props.appConfig.env} serviceWorkerState={serviceWorkerState} >
            <Home />
          </Layout>
        </Route>
        <Route exact path="/invitation/:invitationCode">
          <Layout env={props.appConfig.env} serviceWorkerState={serviceWorkerState} >
            <Invitation />
          </Layout>
        </Route>
        <AuthorizedRoute exact path="/receipts/:receiptTypeId?" >
          <Layout env={props.appConfig.env} serviceWorkerState={serviceWorkerState} >
            <ListReceipts />
          </Layout>
        </AuthorizedRoute>
        <AuthorizedRoute exact path="/reception/:receiptId?" >
          <Layout env={props.appConfig.env} serviceWorkerState={serviceWorkerState} >
            <Reception />
          </Layout>
        </AuthorizedRoute>
        <AuthorizedRoute exact path="/picking/:receiptId?" >
          <Layout env={props.appConfig.env} serviceWorkerState={serviceWorkerState} >
            <Picking />
          </Layout>
        </AuthorizedRoute>
        <AuthorizedRoute exact path="/release/:receiptId?" >
          <Layout env={props.appConfig.env} serviceWorkerState={serviceWorkerState} >
            <Release />
          </Layout>
        </AuthorizedRoute>
        <AuthorizedRoute exact path="/inventories" >
          <Layout env={props.appConfig.env} serviceWorkerState={serviceWorkerState} >
            <ListInventories />
          </Layout>
        </AuthorizedRoute>
        <AuthorizedRoute exact path="/inventory/:inventoryId" >
          <Layout env={props.appConfig.env} serviceWorkerState={serviceWorkerState} >
            <Inventory />
          </Layout>
        </AuthorizedRoute>
        <Route exact path="/nfc/:key">
          <Layout env={props.appConfig.env} serviceWorkerState={serviceWorkerState} >
            <NFC />
          </Layout>
        </Route>
        <AuthorizedRoute exact path="/barcodedemo">
          <Layout env={props.appConfig.env} serviceWorkerState={serviceWorkerState} >
            <BarcodeDemo />
          </Layout>
        </AuthorizedRoute>
        {/* # ··»» */}
        
        <Route exact path="/login">
          {({ location }) => <Login serviceWorkerState={serviceWorkerState} appConfig={props.appConfig} returnurl={queryToObject(location.search).returnurl} />}
        </Route>
      </Switch>
    </HashRouter>
  );
}
